import PropTypes from 'prop-types';

/** 统计页卡片骨架屏加载占位（与父级底色合一；fill 时为大块静态骨架） */
const StatisticsCardLoading = ({ className = '', label = null, style, fill = false, role = 'status', 'aria-label': ariaLabel }) => (
	<div
		className={['statistics-card-loading', fill ? 'statistics-card-loading--fill' : null, className].filter(Boolean).join(' ')}
		style={style}
		role={role}
		aria-busy='true'
		aria-label={ariaLabel || label || '加载中'}
	>
		<div className='statistics-card-loading__skeleton' aria-hidden>
			<span className='statistics-card-loading__bone statistics-card-loading__bone--legend' />
			<span className='statistics-card-loading__bone statistics-card-loading__bone--plot' />
		</div>
	</div>
);

StatisticsCardLoading.propTypes = {
	className: PropTypes.string,
	label: PropTypes.node,
	style: PropTypes.object,
	fill: PropTypes.bool,
	role: PropTypes.string,
	'aria-label': PropTypes.string,
};

export default StatisticsCardLoading;
